import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, tap} from 'rxjs/operators';
import {logError} from '../error-handling/error-handling.actions';
import {parseContextDataJson} from './context-data';
import * as contextActions from './context-data.actions';
import {EventEmitterService} from '../event-emitter/event-emitter.service';
import {contextBlobIsValid} from './validators/context-blob-validator';

@Injectable()
export class ContextDataEffects {
  loadContextData$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(contextActions.loadContextData),
      map(({contextJson}) => {
        const result = parseContextDataJson(contextJson);
        if (!contextBlobIsValid(result)) {
          throw new Error('Invalid context data');
        }
        return contextActions.loadContextDataSuccess({context: result});
      }),
      catchError(err => {
        return of(
          contextActions.loadContextDataFailure({
            error: {
              error: err,
              message: 'There was a problem parsing the context data.',
            },
          }),
        );
      }),
    );
  });

  loadContextDataFailure$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(contextActions.loadContextDataFailure),
      tap(error => {
        this.eventEmitterService.addOnError({
          message: error.error.message,
          code: 400,
          data: {...error},
        });
      }),
      map(logError),
    );
  });

  constructor(
    private actions$: Actions,
    private eventEmitterService: EventEmitterService,
  ) {}
}
